import { watch } from 'vue'
import { useUserStore } from '@/stores/user'
import { normalizePermissions, hasPermission } from '@/utils/permission'

export default {
  mounted(el, binding) {
    const userStore = useUserStore()
    const required = normalizePermissions(binding.value)

    const apply = () => {
      const allowed = hasPermission(required, {
        permissions: userStore.permissions,
        roleKeys: userStore.roleKeys
      })
      el.style.display = allowed ? '' : 'none'
    }

    apply()
    el.__permissionStop = watch(
      () => [userStore.permissions, userStore.roleKeys],
      () => apply(),
      { deep: true }
    )
  },
  updated(el, binding) {
    const userStore = useUserStore()
    const required = normalizePermissions(binding.value)
    const allowed = hasPermission(required, {
      permissions: userStore.permissions,
      roleKeys: userStore.roleKeys
    })
    el.style.display = allowed ? '' : 'none'
  },
  unmounted(el) {
    if (el.__permissionStop) {
      el.__permissionStop()
    }
  }
}
